export type UmbDirectionType = 'Ascending' | 'Descending';

export const UmbDirection = Object.freeze({
	ASCENDING: 'Ascending',
	DESCENDING: 'Descending',
});
